import { useEffect }    from 'react';
import { connect }      from 'react-redux';
import {useParams}      from 'react-router-dom';

// Redux
import {getBranches}    from '../../redux/actions/Branches';
// Components
import Head         from '../global/Head';
import Tables       from './Tables';
import Form         from './Form';
// Values
import {StateView}  from '../../values';
// Api
import {getData}    from '../../utils/branches';

const Index = ({stateView, token, getBranches}) => {
    let { id }  = useParams();
    const GetData = async() =>{
        if(id){
            const res = await getData(token, `/${id}`)
            getBranches(res.data)
        } else{
            const res = await getData(token)
            getBranches(res.data)
        }
    }
    useEffect(() =>{
        if(token){
            if(stateView === StateView.state1){
                GetData()
            }
        }
    })
    return (
        <div>
            <Head title='Sucursales' />
            {
                stateView===StateView.state1?
                    <Tables />
                :
                    <Form />
            }
        </div>
    );
};

const mapStateToProps = state =>({
    stateView:      state.View.stateView,
    token:          state.Panel.token
})

export default connect(mapStateToProps, {getBranches})(Index);
